import CompletedOrders from './completedOrders'

export default CompletedOrders;
